import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import { useTranslation } from 'react-i18next';

const LogoutConfirmationModal = ({ isOpen, onCloseClick, onLogoutClick, isLoading = false }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.Power size={60} className="text-primary" />
          <div className="fs-4 pt-2 text-primary">{t('areYouSure')}</div>
          <div className="fs-6 pt-2">{t('logoutMessage')}</div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-primary">
          {t('cancel')}
        </Button>
        <Button
          onClick={onLogoutClick}
          className="d-flex justify-content-center align-items-center gap-2 px-5 bg-danger border-danger">
          {t('logout')}
          {isLoading ? <Spinner size="sm" color="light" /> : null}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

LogoutConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onLogoutClick: PropTypes.func
};

export default LogoutConfirmationModal;
